<div class="driver-actvity-container">

    <div style="display: flex ;align-items: center;  gap: 10px;">

        <!--if report neads to choose start and end date-->
        <div class="row" style="padding-top:  3px;">
            <div class="form-group" class="col-md-6">


                <input *ngIf="isDateOnly" type="text" class="form-control input-sm" bsDatepicker name="startDate"
                    placeholder="Date Début" [(ngModel)]="repport.dateInterval.startDate" [bsConfig]="{
                    dateInputFormat: 'DD-MM-YYYY',
                    containerClass: 'theme-dark-blue'
                  }" [maxDate]="maxDate" placement="bottom" autocomplete="off" class="calender-item" />

                <input *ngIf="!isDateOnly" type="text" class="form-control input-sm" bsDatepicker name="startDate"
                    placeholder="Date Début" [(ngModel)]="repport.dateInterval.startDate" [bsConfig]="{
                    dateInputFormat: 'DD-MM-YYYY HH:mm',
                    containerClass: 'theme-dark-blue'
                  }" [maxDate]="maxDate" placement="bottom" autocomplete="off" class="calender-item" />

            </div>
            <div class="form-group" class="col-md-6">

                <input *ngIf="isDateOnly" type="text" class="form-control input-sm" bsDatepicker name="endDate"
                    placeholder="Date Fin" [(ngModel)]="repport.dateInterval.endDate" [bsConfig]="{
                        dateInputFormat: 'DD-MM-YYYY',
                        containerClass: 'theme-dark-blue'
                    }" [minDate]="repport.dateInterval.startDate" placement="bottom" autocomplete="off"
                    class="calender-item" />

                <input *ngIf="!isDateOnly" type="text" class="form-control input-sm" bsDatepicker name="endDate"
                    placeholder="Date Fin" [(ngModel)]="repport.dateInterval.endDate" [bsConfig]="{
                        dateInputFormat: 'DD-MM-YYYY HH:mm',
                        containerClass: 'theme-dark-blue'
                    }" [minDate]="repport.dateInterval.startDate" placement="bottom" autocomplete="off"
                    (ngModelChange)="setTimeTo2359()" class="calender-item" />

            </div>
        </div>

        <div class="inputs-container">
            <!-- choose report option (all vehicule ,by group or by vehicule)-->
            <div>

                <select class="form-control" [(ngModel)]="Selectedoption" (change)="onSelectingReportOf()"
                    name="selectedoption" class="calender-item">
                    <option style="font-size: 11px" *ngFor="let opt of selectReportOf" [value]="opt.name">
                        {{ opt.label }}
                    </option>
                </select>

            </div>
            <!--display al groups if user has choose it-->
          <div *ngIf="this.repport.rapportPayloadDto.byGroups ">
    <div class="custom-dropdown">
        <div class="dropdown-toggle-box" (click)="toggleGroupsDropdown()">
            <span>{{ getSelectedGroupsDisplay() }}</span>
            <i class="fa" [ngClass]="isGroupsDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>

        <div class="dropdown-panel" *ngIf="isGroupsDropdownOpen">
            <label class="dropdown-item select-all">
                <input type="checkbox" [checked]="isAllGroupsSelected()" (change)="toggleSelectAllGroups()" />
                Select All
            </label>

            <input type="text" class="dropdown-search" placeholder="Search"
                [(ngModel)]="groupsSearchText" (ngModelChange)="onGroupsSearchChange()" />

            <div class="dropdown-list">
                <label class="dropdown-item" *ngFor="let group of filteredGroupsItems">
                    <input type="checkbox" [checked]="isGroupChecked(group)" (change)="toggleGroupCheck(group)" />
                    {{ group.text }}
                </label>
            </div>
        </div>
    </div>
</div>

            <!-- display all vehicules of user choose this option-->
            <div *ngIf="this.repport.rapportPayloadDto.byVehicules ">
    <div class="custom-dropdown">
        <div class="dropdown-toggle-box" (click)="toggleVehiculesDropdown()">
            <span>{{ getSelectedVehiculesDisplay() }}</span>
            <i class="fa" [ngClass]="isVehiculesDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>

        <div class="dropdown-panel" *ngIf="isVehiculesDropdownOpen">
            <label class="dropdown-item select-all">
                <input type="checkbox" [checked]="isAllVehiculesSelected()" (change)="toggleSelectAllVehicules()" />
                Select All
            </label>

            <input type="text" class="dropdown-search" placeholder="Search"
                [(ngModel)]="vehiculesSearchText" (ngModelChange)="onVehiculesSearchChange()" />

            <div class="dropdown-list">
                <label class="dropdown-item" *ngFor="let vehicule of filteredVehiculesItems">
                    <input type="checkbox" [checked]="isVehiculeChecked(vehicule)" (change)="toggleVehiculeCheck(vehicule)" />
                    {{ vehicule.text }}
                </label>
            </div>
        </div>
    </div>
</div>
<div>
    <input type="text" class="duree-input" name="duree"
        placeholder="Durée (min)" [(ngModel)]="duree" />
</div>
            <!-- Nouveau select POI -->
       <div class="custom-dropdown">
    <div class="dropdown-toggle-box" (click)="togglePoiDropdown()">
        <span>{{ getSelectedPoiDisplay() }}</span>
        <i class="fa" [ngClass]="isPoiDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </div>

    <div class="dropdown-panel" *ngIf="isPoiDropdownOpen">
        <label class="dropdown-item select-all">
            <input type="checkbox" [checked]="isAllPoiSelected()" (change)="toggleSelectAllPoi()" />
            Select All
        </label>

        <input type="text" class="dropdown-search" placeholder="Chercher..."
            [(ngModel)]="poiSearchText" (ngModelChange)="onPoiSearchChange()" />

        <div class="dropdown-list">
            <label class="dropdown-item" *ngFor="let poi of filteredPoiSearch">
                <input type="checkbox" [checked]="isPoiChecked(poi)" (change)="togglePoiCheck(poi)" />
                {{ poi.name }}
            </label>
        </div>
    </div>
</div>



        </div>

        

    </div>
    <div class="action-buttons">
           <div >
            <button *ngIf=" !isSending" class="download-button"
                style="background: rgba(6, 129, 163, 0.788); color: beige;" (click)="openAutoSend()">
<i class="fa fa-share-square" style="font-size: 14px;"></i>           </button>
            <div *ngIf="isSending" class="download-button"
                style="background: rgba(6, 129, 163, 0.788);color: beige; size:inherit;">
                <span class="display-loader"></span>
            </div>
        </div>
        <div >
            <button *ngIf=" !isShowingExcel" class="download-button"
                style="background: rgba(0, 128, 0, .788); color: beige;" (click)="showExcel()">
                <i class="fa fa-file-excel-o" style="font-size: 14px;"></i>
            </button>
            <div *ngIf="isShowingExcel" class="download-button"
                style="background: rgba(0, 128, 0, .788);color: beige; size:inherit;">
                <span class="display-loader"></span>
            </div>
        </div>





        <!-- Global Download Button (if needed) -->
        <div>
            <button *ngIf=" !isDownloading" class="download-button" (click)="downloadExcel()">
                <mat-icon style="   height: 20px;
    width: 24px;font-size: 18px; ">download</mat-icon>
            </button>
            <div *ngIf="isDownloading" class="download-button">
                <span class="loader"></span>
            </div>
        </div>
    </div>
</div>